import React from 'react';

const ApplyNowSection = ({ onApplyClick }) => {
  return (
    <div className="relative flex flex-col items-center justify-center py-12 bg-white overflow-hidden">
      <p className="text-xl md:text-3xl font-medium text-center text-gray-800 mt-3 mb-8 z-20">
        Start Your Journey Today!
      </p>
      <button
        onClick={onApplyClick}
        className="mb-6 text-center bg-[#F6A600] hover:bg-[#272262] hover:text-white transition-all duration-300 text-black text-base md:text-3xl py-2 px-32 border-2 rounded-3xl inline-block uppercase z-20"
      >
        APPLY NOW
      </button>

      <div className="absolute inset-0 z-10">
        <svg
          className="absolute top-6 left-6 w-[150px] h-[150px] rounded-[100%] opacity-30"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
          fill="none"
        >
          <pattern
            id="grid"
            width="10"
            height="10"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="2" cy="2" r="1.5" fill="gray" />
          </pattern>
          <rect width="200" height="200" fill="url(#grid)" />
        </svg>

        <svg
          className="absolute top-[40%] left-[20%] w-[250px] h-[250px] rounded-[100%] opacity-20"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
          fill="none"
        >
          <pattern
            id="grid"
            width="10"
            height="10"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="2" cy="2" r="1.5" fill="gray" />
          </pattern>
          <rect width="200" height="200" fill="url(#grid)" />
        </svg>

        <div className="absolute top-10 right-20 w-8 h-8 border border-gray-300 rotate-45 opacity-30"></div>
        <div className="absolute bottom-16 left-24 w-24 h-24 bg-gray-100 rounded-full opacity-30"></div>
        <div className="absolute bottom-5 right-10 w-10 h-10 border border-gray-400 rotate-45 opacity-30"></div>
      </div>
    </div>
  );
};

export default ApplyNowSection;
